import React from 'react';
import {motion} from 'framer-motion';
import {useInView} from 'framer-motion';
import {useRef} from 'react';

const Vision = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, {once: true, margin: "-100px"});

  return (
    <section id="vision" className="py-20 bg-white w-full" ref={ref}>
      <div className="container mx-auto px-6">
        <motion.div 
          initial={{opacity: 0, y: 50}} 
          animate={isInView ? {opacity: 1, y: 0} : {opacity: 0, y: 50}} 
          transition={{duration: 0.8}}
          className="max-w-4xl mx-auto text-center"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-8">
            Vision
          </h2>
          <div className="w-24 h-1 bg-azure-600 mx-auto mb-12"></div>
          <p className="text-xl text-gray-700 leading-relaxed">
            Unsere Vision: KI-Technologie wird zum Standard in der digitalen Kundenkommunikation zwischen Unternehmen, Kunden und Partnern – effizient, automatisiert, ergebnisorientiert für nachhaltige Geschäftsprozesse.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Vision;